export default __webpack_public_path__ + "static/media/no_data.76df6b84.png";